// extracted by mini-css-extract-plugin
export default {"home":"Home_home__ymPq-","home1":"Home_home1__xyKqQ"};